export default {
  getClientLoginConfigData: '/json/ExtranetSecurityJson/getloginadvanced'
}
